export default __webpack_public_path__ + "static/media/category.9127f1eb.svg";